import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { PaymentSummaryParamsDto, PaymentSummaryDataDto } from '@data/data/models/payment-summary.dto';
import { ErrorType } from '@data/domain/enums/error-type';
import { CompatiblePaymentMethodMapper } from '@presentation/mappers/compatible-payment-method/compatible-payment-method.mapper';
import { PaymentViewModel } from '@presentation/view-models/payment-method.view-model';
import { PaymentMethodUsecase } from '@usecase/payment-method/payment-method.usecase';
import { PaymentSummaryUsecase } from '@usecase/payment-summary/payment-summary.usecase';
import { catchError, map, switchMap, throwError } from 'rxjs';

export const paymentResolver: ResolveFn<PaymentViewModel> = (route: ActivatedRouteSnapshot) => {
    const paymentMethodUsecase = inject(PaymentMethodUsecase);
    const paymentSummaryUsecase = inject(PaymentSummaryUsecase);
    const router = inject(Router);

    const compatiblePaymentMethodMapper = new CompatiblePaymentMethodMapper();
    const bid = route.params['bid'];

    const paymentSummaryParams: PaymentSummaryParamsDto = {
        bid
    };
    return paymentSummaryUsecase.execute(paymentSummaryParams).pipe(
        switchMap((paymentSummary: PaymentSummaryDataDto) =>
            paymentMethodUsecase.execute().pipe(
                map((payment) => {
                    return compatiblePaymentMethodMapper.mapFrom(payment, paymentSummary);
                }),
                catchError((error) => throwError(() => error))
            )
        ),
        catchError(error => {
            router.navigate([`error/${ErrorType.FAILED}`], { queryParams: { redirect_to: window.location.href } });
            return throwError(() => error);
        })
    );
};
